import { HttpService } from '@/infra'
import type { TDocumentosPessoa, TTipoDocumento } from '@/shared//envio-documentos'

export interface TDocumentoLeadRepresado {
  tipo: TTipoDocumento
  dataEnvio: string
}

export interface TGetDocumentosLeadRepresadoResponse {
  documentos: TDocumentoLeadRepresado[]
}

export class GetDocumentosLeadRepresadoService extends HttpService {
  execute = async (clienteId: string) => {
    return this.http.get<TDocumentosPessoa>(`/api/v2/Cliente/leadRepresado/${clienteId}/documentos`)
  }
}
